import {useAppSelector} from "./redux";
import {selectCurrentUser} from "../features/users/model/selectors";
import {Permissions, permissionsOf} from "../models/permissions";

/** Способности текущего пользователя (ROLES.md § 4). По образцу useIsReadOnly. */
export const usePermissions = (): Permissions => permissionsOf(useAppSelector(selectCurrentUser));
